import defaultAttributes from '../defaultAttributes';

const Axis3d = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M4 4v16h16' }], ['path', { d: 'm4 20 7-7' }]],
];

export default Axis3d;
